<mat-card *ngIf="mailRecipientData" class="mat-elevation-z2 px-24 py-16 recipient-selector-card">
    <div class="d-flex flex-row align-items-center justify-content-between">
        <div class="d-flex flex-column" style="width: 474px">
            <div class="d-flex align-items-center mb-8">
                <div class="mat-body-2 text-black m-0 section-heading">{{ mailRecipientData.title }}</div>
                <span 
                    class="info-tooltip material-icons-outlined ml-4"
                    (mouseover)="!popOverMenuTrigger.menuOpen && popOverMenuTrigger.openMenu()" 
                    >info
                    <button 
                        #popOverMenuTrigger="matMenuTrigger" 
                        [matMenuTriggerFor]="popOverMenu" 
                        class="hidden"
                    ></button>
                    <mat-menu #popOverMenu="matMenu" class="info-menu-panel px-20 py-12" (click)="$event.stopPropagation()">
                        <div (mouseleave)="popOverMenuTrigger.menuOpen && popOverMenuTrigger.closeMenu()" (click)="$event.stopPropagation()" class="mat-subtitle-2">
                            {{mailRecipientData.tooltip}}
                        </div>
                    </mat-menu>
                </span>
            </div>
            <div class="mat-subtitle-2 text-hint m-0">
                {{ mailRecipientData.description }}
            </div>
        </div>

        <button mat-flat-button color="accent" (click)="openSheet()" class="mx-8" [disabled]="disabled">
            <mat-icon>add</mat-icon>
            <span class="px-5">{{ mailRecipientData.createBtnLabel }}</span>
        </button>
    </div>
    
    <mat-card appearance="outlined" *ngIf="mailRecipientData?.warnNote?.length" class="notify-warn-card mat-elevation-z0 mt-16" style="min-height: fit-content;">
        <div class="d-flex align-items-center">
            <mat-icon>warning</mat-icon>
            <div class="mat-subtitle-2 m-0">{{mailRecipientData?.warnNote}}</div>
        </div>
    </mat-card>

    <div class="mt-16" *ngIf="mailRecipientData?.availableRecipients?.length">
        <mat-chip-listbox class="tag-chip-list" #chipList>
            <mat-chip-option 
                *ngFor="let recipientValue of selectedRecipients; trackBy: trackByFn" 
                color="accent"
                class="bg-accent text-accent"
                [class.chip-removable]="!disabled"
                style="font-weight: 500;"
                [selectable]="false" 
                [disabled]="disabled"
            >
                {{ recipientValue.name }}
                <button class="mat-chip-remove-icon" (click)="removeRecipient(recipientValue.id)" [disabled]="disabled">
                    <mat-icon class="text-accent" style="font-size: 20px;">cancel</mat-icon>
                </button>
            </mat-chip-option>
        </mat-chip-listbox>
    </div>
    
</mat-card>

<ng-template #sheetTemp>
    <div *ngIf="mailRecipientData?.formData" class="preview-container">
        <span>
            <div class="head-section">
                <div class="d-flex flex-row align-items-center justify-content-between">
                    <div class="mat-body-2 text-black mb-0">{{ mailRecipientData?.formData?.title }}</div>

                    <button mat-icon-button (click)="closeForm(true)">
                        <mat-icon class="text-hint">cancel</mat-icon>
                    </button>
                </div>

                <div class="mat-subtitle-2 text-hint mb-8" style="width: 700px;">
                   {{ mailRecipientData?.formData?.description }}
                </div>
                <mat-divider></mat-divider>
                
            </div>

            <div class="content-section">
                <div class="tag-check-list">
                    <div class="mat-subtitle-1 m-0">Active Users</div>
                    <mat-divider></mat-divider>
                    <mat-list #recipientList class="p-0">
                        <ng-container *ngFor="let _recipientsItem of recipientListValues; let i = index; let lastitem = last; trackBy: trackByFn">
                            <mat-list-item>
                                <div class="d-flex align-items-center">
                                    <mat-checkbox 
                                      [checked]="recipientListValues[i].checked" 
                                      (change)="listChange($event.checked, i)" 
                                      ></mat-checkbox>
                                    <span style="max-width: 580px;" class="text-truncate pl-16">{{_recipientsItem.data.name}}</span>
                                </div>
                            </mat-list-item>
                            <mat-divider *ngIf="!lastitem"></mat-divider>
                        </ng-container>
                    </mat-list>
                </div>
            </div>
        </span>


        <div class="action-section">
            <div class="d-flex align-items-center justify-content-between h-48">
                <button mat-button class="mx-8" (click)="clearAll()">
                    CLEAR ALL
                </button>
                <span>
                    <button mat-button class="mx-8" (click)="closeForm(true)">
                        CANCEL
                    </button>
                    <button mat-button color="accent" (click)="closeForm()">
                        DONE
                    </button>
                </span>
            </div>
        </div>
    </div>
</ng-template>